import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useParams,
} from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import FullPageLoader from './FullPageLoader';
import AlertBox from './AlertBox';
import Header from './Header';
import Recipies from '../pages/Recipies';
import RecipieDetail from '../pages/RecipieDetail';
import Faqs from '../pages/Faqs';
import AdminOrder from '../pages/AdminOrder';
import AdminBlogs from '../pages/AdminBlogs';
import Blogs from '../pages/Blogs';
import BlogPost from '../pages/BlogPost';
import NewBlogPost from '../pages/NewBlogPost';
import EditBlogPost from '../pages/EditBlogPost';
import AboutUs from '../pages/AboutUs';
import PilotProducts from '../pages/pilot/Products';
import PilotProductDetail from '../pages/pilot/ProductDetail';
import PilotCart from '../pages/pilot/Cart';
import PilotInstoreCheckout from '../pages/pilot/InstoreCheckout';
import PilotMakePayment from '../pages/pilot/PilotMakePayment';
import PilotAuthentication from '../pages/pilot/PilotAuthentication';
import RequirePilotAuth from './RequirePilotAuth';
import V2App from '../v2/app/V2App';
import StripV2Redirect from '../routing/StripV2Redirect';
import { RedirectPreserveSearch } from '../routing/RedirectPreserveSearch';
import LegacyRedirect from '../routing/LegacyRedirect';
import { LEGACY_EXACT_REDIRECTS } from '../routing/legacyRedirects';

function PilotProductLegacyRedirect() {
  const { id } = useParams();
  return <Navigate to={`/pilot/home/${id}`} replace />;
}

function AnimatedRoutes() {
  const location = useLocation();
  const routesKey = location.pathname.startsWith('/pilot') ? location.pathname : 'v2';

  return (
    <AnimatePresence>
      <Routes location={location} key={routesKey}>
        <Route path="/v2/*" element={<StripV2Redirect />} />

        {Object.entries(LEGACY_EXACT_REDIRECTS).map(([from, to]) => (
          <Route
            key={from}
            path={from}
            element={<RedirectPreserveSearch to={to} />}
          />
        ))}
        <Route path="/home/*" element={<RedirectPreserveSearch to="/" />} />
        <Route path="/catalog" element={<LegacyRedirect />} />
        <Route path="/catalog/*" element={<LegacyRedirect />} />

        <Route element={<FullPageLoader />}>
          <Route element={<AlertBox />}>
            <Route element={<Header />}>
              <Route path="/aboutUs" element={<AboutUs />} />
              <Route path="/recipies" element={<Recipies />} />
              <Route path="/recipieDetails/:id" element={<RecipieDetail />} />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:urlId" element={<BlogPost />} />
              <Route path="/admin-blogs" element={<AdminBlogs />} />
              <Route path="/blogs/new" element={<NewBlogPost />} />
              <Route path="/blogs/edit/:postId" element={<EditBlogPost />} />
              <Route path="/admin-order" element={<AdminOrder />} />
              <Route path="/pilot/login" element={<PilotAuthentication />} />
              <Route path="/pilot" element={<RequirePilotAuth />}>
                <Route path="products" element={<Navigate to="/pilot/home" replace />} />
                <Route path="products/:id" element={<PilotProductLegacyRedirect />} />
                <Route path="home" element={<PilotProducts />} />
                <Route path="home/:id" element={<PilotProductDetail />} />
                <Route path="cart" element={<PilotCart />} />
                <Route path="delivery" element={<PilotInstoreCheckout />} />
                <Route path="make-payment" element={<PilotMakePayment />} />
              </Route>
            </Route>
          </Route>
        </Route>

        <Route path="/*" element={<V2App />} />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
